import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useRecentlyViewed } from "@/contexts/RecentlyViewedContext";
import ProductCard from "./ProductCard";

export default function RecentlyViewed({ excludeId, limit = 4 }) {
  const { items } = useRecentlyViewed();
  const visible = items.filter((p) => p.id !== excludeId).slice(0, limit);
  if (visible.length === 0) return null;

  return (
    <section className="mt-20 border-t border-[#E6D4CC] pt-14" data-testid="recently-viewed">
      <div className="mb-8 flex items-end justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-[#6B5158]">Your recent picks</div>
          <h2 className="mt-2 font-display text-3xl md:text-4xl">Recently <span className="font-display-soft">viewed</span></h2>
        </div>
        <Link to="/catalog" className="hidden items-center gap-1 text-sm text-[#9D5C6C] hover:underline md:inline-flex">Keep exploring <ArrowRight size={14} /></Link>
      </div>
      <div className="grid grid-cols-2 gap-x-4 gap-y-10 md:grid-cols-4">
        {visible.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
      </div>
    </section>
  );
}
